<template>
  <div>
    <div class="ubold-title" style="margin-bottom: 40px">域名订单</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">订单状态：</div>
          <div class="bj-rows">
            <div :class="['item-radio',{ active: -1 === searchObj.tradeState }]"
              @click="onCheckTradeStateList(-1)">
              全部
            </div>
            <div :class="['item-radio',{ active: item.value === searchObj.tradeState }]"
              v-for="item in tradeStateList"
              :key="item.value"
              @click="onCheckTradeStateList(item.value)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item">
          <div class="name" style="margin-right: 10px">创建时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            v-model="searchObj.value"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom"
            placeholder="创建时间"
            style="width: 200px"
            @on-change="onTimeChange"
          ></DatePicker>
        </div>
        <div class="item" style="margin-left: 20px;">
          <Button class="bj-search-btn-F85A36" type="primary" style="margin-right: 20px" @click="onSearch">搜索</Button>
          <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ searchObj.total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="goodsNames" slot-scope="{ row }">
          {{ row.ymList ? `${row.ymList[0]}...` : '--'}}
        </template>
        <template slot="tradeState" slot-scope="{ row }">
          <div>
            {{ row.state | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div class="bj-rows">
            <div class="table-btn" v-if="row.state == 0" @click="onPay(row)">付款</div>
            <div class="table-btn" v-if="row.state == 0" @click="onCancel(row)">取消</div>
            <div class="table-btn" @click="onDetail(row)">详情</div>
          </div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { orderPageList, orderCancel } from "api/domain.js";
export default {
  name: "order",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "待支付";
          break;
        case 1:
          title = "交易成功";
          break;
        case 2:
          title = "已取消";
          break;
        case 3:
          title = "已过期";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      searchObj: {
        tradeState: -1, // 支付状态 0：待支付 1：交易成功 2：已取消 3：已过期
        startCreatedTime: "",
        endCreatedTime: "",
        value: "", // 创建时间
        page: 1,
        limit: 20,
        total: 0,
      },
      tradeStateList: [
        {
          value: 0,
          name: "待支付",
        },
        {
          value: 1,
          name: "交易成功",
        },
        {
          value: 2,
          name: "已取消",
        },
        {
          value: 3,
          name: "已过期",
        },
      ],
      columns: [
        {
          title: "订单号",
          align: "center",
          key: "id",
        },
        {
          title: "产品名称",
          align: "center",
          slot: "goodsNames",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "订单金额",
          align: "center",
          key: "total",
        },
        {
          width: 100,
          title: "状态",
          align: "center",
          slot: "tradeState",
        },
        {
          width: 200,
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
    };
  },
  created() {
    this.onPageChange(1);
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          start: this.searchObj.startCreatedTime,
          end: this.searchObj.endCreatedTime,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
        };
        if(this.searchObj.tradeState != -1){
          params.status= this.searchObj.tradeState;
        }
        this.tableLoading = true;
        const { code, data } = await orderPageList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    onTimeChange(val) {
      this.searchObj.startCreatedTime = val[0];
      this.searchObj.endCreatedTime = val[1];
    },
    // 取消订单
    async onCancel(val) {
      try {
        let params = {
          orderNo: val.id,
        };
        const { code, result } = await orderCancel(params);
        if (code === 200 && result) {
          this.req_getList();
          this.$Message.success("操作成功!");
        } else {
          this.$Message.warning("操作失败!");
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 切换状态
    onCheckTradeStateList(val) {
      this.searchObj.tradeState = val;
      this.onPageChange(1);
    },
    // 付款
    onPay(val) {
      this.$router.push({ path: "/cart", query: { id: val.id } });
    },
    // 详情
    onDetail(val) {
      this.$router.push({
        path: "/my/order/detail",
        query: { id: val.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .item-radio{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
    border: 1px solid #fff;
    min-width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    transition: all .3s;
  }
  .item-radio.active {
    color: #fff;
    background-color: #F85A36;
  }

</style>

